export default __webpack_public_path__ + "static/media/received-by-agent.4a81dce9.svg";